import { render, staticRenderFns } from "./listClients.vue?vue&type=template&id=764fa9bd&scoped=true"
import script from "./listClients.vue?vue&type=script&lang=js"
export * from "./listClients.vue?vue&type=script&lang=js"
import style0 from "./listClients.vue?vue&type=style&index=0&id=764fa9bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764fa9bd",
  null
  
)

export default component.exports